module.exports = __webpack_public_path__ + "img/comic_portrait.684e69bb.jpg";